import Link from 'next/link';
import React from 'react';
//#region [Styles]

//#endregion

//#region [Props]
type aProps = Omit<React.ComponentProps<"a">, "href" | "target" | "children" | "className">;
type FilmwebLinkProps = {
	to: string | null | undefined;
	className?: string;
	target?: string;
	children?: React.ReactNode;
    prefetch?: boolean;
    hardLink?: boolean;
} & aProps;
//#endregion



//#region [Component]
// TODO: Trenger vi å tenke på scroll restoration?
export default function FilmwebLink({ to, className, target, children, prefetch, hardLink, ...rest }: FilmwebLinkProps) {
	if (!to) {
		// if it is an empty string
		return (
			<div className={className}>
				{children}
			</div>
		);
	}

	if (isInternalLink(to) && hardLink !== true) {
        const _prefetch = resolvePrefetch(prefetch);
		const relativeUrl = makeRelative(to);
		return <Link prefetch={_prefetch} href={relativeUrl} className={className} {...rest}>
				{children}
		</Link>

	}
	return <a href={to} className={className} target={target} {...rest}>
		{children}
	</a>

}
//#endregion

//#region [Other]
// use the prefetch prop if explicitly specified, otherwise disable it if the env says so,
// otherwise undefined so Next.js uses its default ("auto") prefetching
export function resolvePrefetch(prefetch: boolean | undefined): boolean | undefined {
	return prefetch ?? (process.env.NEXT_PUBLIC_GLOBAL_PREFETCH_DISABLED === "true" ? false : undefined);
}

// Our own site for the current brand. Other subdomains (id., search. etc) are separate services and stay external links.
const SITE_DOMAIN = process.env.NEXT_PUBLIC_WEBSITE_BRAND === "kinodk" ? "kino\\.dk" : "filmweb\\.no";
const OWN_SITE_URL = new RegExp(`^(?:(?:https?:)?//(?:www|stage|local|(?:.*?.dev))\\.${SITE_DOMAIN})?(/.*)`);

function makeRelative(url: string): string {
	const res = OWN_SITE_URL.exec(url);
	if (res?.length ?? 0 >= 2) {
		return res![1];
	}
	return url;
}


function isInternalLink(url: string): boolean {
	return OWN_SITE_URL.test(url);
}

//#endregion